export default "__VITE_ASSET__c6caa697__"